export default __webpack_public_path__ + "static/media/Training_Courses.97dfd9c0.svg";